import type { ToastProviderProps } from './types'

import { Toast as BaseToast } from '@base-ui/react/toast'
import { useEffect, useState } from 'react'

import { createBufferedManager } from './manager'
import { createToastApi, DEFAULT_TIMEOUT_MS, ToastApiContext } from './utils'

export function ToastProvider(props: ToastProviderProps) {
  const [manager] = useState(createBufferedManager)
  const [toastApi] = useState(() => createToastApi(manager))

  // Runs after Base UI's provider effect, so its subscription is in place.
  useEffect(() => {
    manager.flush()
    return manager.pause
  }, [manager])

  return (
    <ToastApiContext value={toastApi}>
      <BaseToast.Provider
        timeout={DEFAULT_TIMEOUT_MS}
        {...props}
        toastManager={manager.base}
      />
    </ToastApiContext>
  )
}
ToastProvider.displayName = 'Toast'
